import { useRoute } from 'vue-router';
import { useRuntimeConfig } from '#app';

/**
 * Getting the current URL can be a bit complicated in hosted environments,
 * when caching is enabled, etc. This helper method tries to make it easy.
 */
export default function useCurrentURL() {
  const route = useRoute();

  const host = useRuntimeConfig().deploymentHost;

  function createUrl(path: string): string {
    return `https://${host}/${path.startsWith('/') ? path.slice(1) : path}`;
  }

  function currentPath() {
    return route.fullPath || `${window.location.pathname}${window.location.search}`;
  }

  return {
    host,
    createUrl,
    currentPath,
    currentUrl: () => createUrl(currentPath()),
  };
}
